<div class="d-flex flex-column justify-content-between gap-2 h-100">
	<div class="d-flex flex-column gap-2">
		<common-text-field [field]="basicInfoform.firstName()"></common-text-field>
		<common-text-field [field]="basicInfoform.middleInit()"></common-text-field>
		<common-text-field [field]="basicInfoform.lastName()"></common-text-field>
		<common-address-field [field]="basicInfoform.address()"></common-address-field>
		<common-select-field [field]="basicInfoform.preferredContact()"></common-select-field>
		<common-select-field [field]="basicInfoform.phoneType()"></common-select-field>
		<common-phone-field [field]="basicInfoform.phone()"></common-phone-field>
		<p class="fs-5 mb-1 mt-2">Do not contact flag is <b>{{basicInfoform.doNotContactFlag() ? 'ON' : 'OFF'}}</b></p>
		<common-text-field [field]="basicInfoform.doNotContactNote()"></common-text-field>
	</div>

	<common-button-row [center]="true">
		<button class="btn btn-standard" (click)="showViewMode()">View</button>
		<button class="btn btn-standard" (click)="setInitialValues()">Revert</button>
		<button #basicInfoSaveBtn class="btn btn-primary">Save Changes</button>
		<button class="btn btn-standard" (click)="onClose()">Close</button>
	</common-button-row>
</div>